import React from 'react';
import PropTypes from 'prop-types';
import { FileIcon as FileIconComponent, defaultStyles } from 'react-file-icon';
import { FileIconContainer } from './styles';

export const FileIcon = ({ filename, extension, size, ...props }) => {
  const itemExtension = extension ?? filename?.replace(/(.+\.)/, '') ?? '';
  const itemStyles = defaultStyles[itemExtension] ?? {};

  return (
    <FileIconContainer height={size} {...props}>
      <FileIconComponent extension={itemExtension} {...itemStyles} />
    </FileIconContainer>
  );
};

FileIcon.propTypes = {
  filename: PropTypes.string,
  extension: PropTypes.string,
  size: PropTypes.string,
};

FileIcon.defaultProps = { size: '80px' };
